export default {
  namespaced: true,
  state: {
    header: null,
    topSection: null,
    bottomSection: null,
    components: []
  },
  getters: {
    header: (state) => state.header,
    topSection: (state) => state.topSection,
    bottomSection: (state) => state.bottomSection,
    components: (state) => state.components
  },
  actions: {
    addToObject({commit}, payload) {
      payload = {...payload, module: 'layoutModule'}
      commit('actionsModule/addToObject', payload, {root: true})
    },
    removeFromArray({commit}, payload) {
      payload = {...payload, module: 'layoutModule'}
      commit('actionsModule/removeFromArray', payload, {root: true})
    },
    addToArray({commit}, payload) {
      payload = {...payload, module: 'layoutModule'}
      commit('actionsModule/addToArray', payload, {root: true})
    },
  }
}